module.exports = __webpack_public_path__ + "img/Rectangle 10301.b488635a.svg";